import dropdownCoercions from './coerce.dropdown';
import { FIELD_TYPES } from '../../utils/constants';

const DEFAULT_BOOLEAN_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

function fromGQL(obj) {
  if (obj.value && obj.value.adminType && obj.value.adminType === FIELD_TYPES.DROPDOWN) {
    const objForDropdown = { ...obj };
    objForDropdown.type = FIELD_TYPES.DROPDOWN;
    return dropdownCoercions.fromGQL(objForDropdown);
  }

  const { value, ...returnableField } = obj;
  if (value && value.options && value.options.length > 0) {
    const conformedOptions = {};
    const optionsOrder = [];
    value.options.forEach((opt) => {
      conformedOptions[opt.value] = {
        value: opt.value,
        label: opt.label,
        shouldDisplay: true,
      };
      optionsOrder.push(opt.value);
    });
    return {
      ...returnableField,
      editors: {
        radioButtonConfig: {
          ...value,
          options: conformedOptions,
          optionsOrder,
          layout: value.layout || 'vertical',
        },
      },
    };
  }
  // Default boolean options when none are configured yet
  const conformedDefaultOptions = {};
  DEFAULT_BOOLEAN_OPTIONS.forEach((opt) => {
    conformedDefaultOptions[opt.value] = { value: opt.value, label: opt.label, shouldDisplay: true };
  });
  return {
    ...returnableField,
    editors: {
      radioButtonConfig: {
        options: conformedDefaultOptions,
        optionsOrder: DEFAULT_BOOLEAN_OPTIONS.map((opt) => opt.value),
        defaultOption: (value && value.defaultOption) || '',
        layout: (value && value.layout) || 'vertical',
      },
    },
  };
}

function overrideFromGQL(override) {
  const { value, ...returnableField } = override;
  const hasDefaultOption = value && Object.prototype.hasOwnProperty.call(value, 'defaultOption');
  const defaultOptionValue = hasDefaultOption ? value.defaultOption : '';

  return {
    ...returnableField,
    editors: {
      defaultOption: defaultOptionValue,
    },
    value: {
      defaultOption: defaultOptionValue,
    },
  };
}

function toGQL({ editors }) {
  const { options, optionsOrder, defaultOption, layout } = editors.radioButtonConfig;
  const orderedKeys = (optionsOrder && optionsOrder.length) ? optionsOrder : Object.keys(options);
  const conformedOptions = orderedKeys.reduce((acc, key) => {
    if (options[key].shouldDisplay) {
      acc.push({ label: options[key].label, value: options[key].value });
    }
    return acc;
  }, []);
  const activeDefault = defaultOption && options[defaultOption] && options[defaultOption].shouldDisplay ?
    defaultOption :
    '';
  return {
    value: {
      defaultOption: activeDefault,
      options: conformedOptions,
      layout: layout || 'vertical',
    },
  };
}

function overrideToGQL(override) {
  const editorDefault = override?.editors?.defaultOption;

  const hasDefaultOption = editorDefault !== undefined && editorDefault !== null;

  return {
    value: hasDefaultOption ? { defaultOption: editorDefault } : null,
  };
}

export default {
  fromGQL,
  toGQL,
  overrideFromGQL,
  overrideToGQL,
};
